module.exports = __webpack_public_path__ + "05_veryshort_gold.8b86a267.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/05_veryshort_gold.png
// module id = dk7Q
// module chunks = 0